import { settings } from '../settings';
import Pusher, { Channel } from 'pusher-js';

export enum PusherEvent {
  CHAT_MESSAGE = 'chat-message',
  LOCATION_UPDATE = 'courier-location-update',
  COMPLETED = 'completed',
  ERROR = 'error',
  HUBSORT_UPDATE = 'hubsort-update',
  HUBSORT_BUNDLE_UPDATE = 'hubsort-bundle-update',
  PROGRESS = 'progress',
  SHIFT_PLANNER_CREATE = 'shift-planner-create',
  SHIFT_PLANNER_UPDATE = 'shift-planner-update',
  SHIFT_PLANNER_DELETE = 'shift-planner-delete',
  SHIFT_PLANNER_PUBLISH = 'shift-planner-publish',
  SHIFT_PLANNER_EXTRA_WORK_UPDATE = 'shift-planner-extra-work-update',
}

let pusherInstance: Pusher | undefined;

function getPusher(): Pusher {
  if (!pusherInstance) {
    Pusher.logToConsole = settings.debugMode;

    if (!settings.pusherKey) {
      throw new Error('settings.pusherKey is undefined');
    }

    pusherInstance = new Pusher(settings.pusherKey, {
      cluster: 'eu',
      forceTLS: true,
    });
  }

  return pusherInstance;
}

export function subscribeToChannel(
  channelName: string,
  event: PusherEvent | string,
  onMessage: (data: any) => void
) {
  const channel: Channel = getPusher().subscribe(channelName);
  channel.bind(event, onMessage);
}

export function unsubscribeFromChannel(channelName: string) {
  // TODO We might need to close clients here in some way. Because of limits of concurrent connections.
  getPusher().unsubscribe(channelName);
}

export function disconnect() {
  if (pusherInstance) {
    pusherInstance.disconnect();
    pusherInstance = undefined;
  }
}
